export const DefaultColors = {
    light: {
     background: "linear-gradient(-60deg,#d8e2f3,#d8e2f3)",
     scope1: '#8497b0',
     scope2: '#0bbbdd',
     scope3: '#0070c0',
     emissionMitigation: '#a9d18e',
     color1:"white",
     color2: "#17214f",
     sideBarBackground:"#17214f",
     sectionTitleColor:"#000000",
     listItemColor:'#ffffff',
     sectionTitleBackgroundColor:"#3b4a94",
     sectionTitleOutlineColor:null,
     infoColor:'#303030',
     textFieldBackground:'#fffff',
     onBoardSideBar:"#EBEBEB",
     buttonColor:"#3b4a94",
     buttonHoverColor:"#4c629d", //#3b4a94",
     buttonDisabledColor:'#a0a0a0',
     cardBorder: "#C6C6C6",
     switchButtonColor:'#17214f',
     sectionTextColor:"#303030",
     cardHeaderColor:'#232f69',
     cardHeader:'#ffffff',
     tableBackground :"#ffffff", 
     searchBarIcon:'#000000',
     reportButton: "#737dad",
     searchBarBackground:'#cecece',
     emissionSwitchBackground:"#3b4a94",
     emissionSwitchActiveText: '#ffffff',
     emissionSwitchInActiveText: '#9da4c9',
     inActiveStepper:"#868c97",
     verification: "#eee",
     activityLog:'#000000',
     appRequestBackground:'#F6F6F6',
     emissionCancelButton:'#888888',
     emissionCancelHover:'#5E5E5E',
     checkBoxColor: "#5764C7",
     emissionCardColor:"#F6F9FF",
     footerText:"#aaaaaa",
     searchBarBorder:"#cecece",
     searchBarHoverBorder: "#cecece",
     cssName:'light',
     textFieldBorder:'#C6C6C6',
     activeTabBgColor : '#ddd',
     regionCss:'lightRegion',
     arrowLeftBackground:"#F0F8TF",
     leftArrowIcon: "#F6F6F6",
     arrowLeftBackground:"#303030",
     radioIcon:"#020945",
     downLoadButton:"#2D3C86",
     downLoadText:"#ffffff",
     reportTable:"#F2F3F7",
     timeLineBg: "#ffffff",
     OBTabBackground:"#ececec",
     OBTabBorderBottom:"#00000030",
     selectedTab: "rgba(0,0,0,0.08)",
     selectedTabBL:"5px solid #3b4a94",
     selectedTabBorderBottom:'#00000030',
     OBChildTabBackground:"rgba(0,0,0,0.05)",
     groupReportChildTB:"#E7E7E7",
     dataEntryTabBackground: "#ddd",
     dataEntryTabBorder:"#ffffff",
     paginationCardColor:"#ddd",
     noColumnColor: '#F6F6F6',
     searchTextColor:'#4b4b4b',
     searchCloseIcon:'#6F7282',
     userManagementBackground: "#F6F6F6",
     reportGenerationBackground:'#F6F6F6',
     feedBackBackground:"#F6F6F6",
     tableRowHoverColor:'#cecece',
    },
    dark: {
     background: "linear-gradient(-60deg,#101841,#202b60)",
     scope1: '#8497b0',
     scope2: '#0bbbdd',
     scope3: '#0070c0',
     emissionMitigation: '#a9d18e',
     color1: "#17214F",
     color2:"#d8e2f3",
     sideBarBackground: "#d8e2f3",
     sectionTitleColor:"#fff9eb",
     searchBarBackground:'#182149',
     listItemColor:'#ffffff90',
     sectionTitleBackgroundColor:"rgba(24, 33, 71, 0.2)",
     sectionTitleOutlineColor:null,
     infoColor:'#c6c6c6',
     textFieldBackground: "#182149",
     onBoardSideBar:"#010637",
     buttonColor:"#2D3C86",
     buttonHoverColor: "#4A5A9D", // or "#24305D" ////"#35469b",
     buttonDisabledColor: "#6D6D6D", // or "rgba(45, 60, 134, 0.5)"
     cardBorder: "#5E5E5E",
     switchButtonColor:'#d8e2f3',
     sectionTextColor:"#C6C6C6",
     cardHeaderColor:"#4d5ca9",
     cardHeader:'#ffffff',
     tableBackground :"#182149",
     searchBarIcon:'#ffffff',
     reportButton: "#1e2a6f",
     searchBarBackground:'#404975',
     emissionSwitchBackground:"#D9D9D925",
     inActiveStepper:"#0f1532",
     verification: "#21265A",
     activityLog:'#fff9eb',
     appRequestBackground:'#020845',
     emissionCancelButton:'#2D3C86',
     emissionCancelHover:'#3b4a94',
     checkBoxColor: "#5161B6",
     emissionCardColor:"#17214f",
     footerText:"#a4a6b0",
     searchBarBorder:'#404975',
     searchBarHoverBorder: "#404975",
     cssName:'dark',
     textFieldBorder:'#5E5E5E',
     activeTabBgColor : '#000534',
     regionCss:'darkRegion',
     leftArrowIcon: "#202b60",
     arrowLeftBackground:"#C6C6C6",
     radioIcon:"#ffffff",
     downLoadButton:"#2D3C86",
     downLoadText:"#ffffff",
     reportTable:"#F2F3F7",
     timeLineBg: "#020845",
     OBTabBackground:"#010637",
     OBTabBorderBottom:"#ffffff30",
     selectedTab: "#252f64",
     selectedTabBL:"5px solid #5161B6",
     selectedTabBorderBottom:'#ffffff30',
     OBChildTabBackground:"#1E254C",
     groupReportChildTB:"#202b60",
     dataEntryTabBackground: "#000534",
     dataEntryTabBorder:"#182149",
     paginationCardColor:"#000534",
     noColumnColor: '#020845',
     searchTextColor:'#C6C6C6',
     searchCloseIcon:'#C6C6C6',
     userManagementBackground: "#182149",
     reportGenerationBackground:'#020845',
     feedBackBackground:"#202b60",
     
      tableRowHoverColor:'#4c629d'

    },
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
    textFieldSize:'15px',
    dropDownColor:"#04c500",
    buttonText:'#ffffff',
    parentLevel:"#729fcf",
    parentText: "#212529",
    parentOutline:"#212529",
    facilityLevel: "#f8cbad",
    facilityText: "#E13504",
    facilityOutline:"#212529",
    subsidiaryLevel: "#d0cece",
    subsidiaryText: "#5A5959",
    subsidiaryOutline: "#212529",
    connectionLine:"#ffe699",
    excelInfo:"white",
    activeSwitchColor:"#020845",
    inActiveSwitchColor: '#2d3c86',
    inActiveEmissionColor: '#9da4c9',
    inActiveTextColor: 'white',
    switchOutline: 'white',
    tableBottom:"#5E5E5E",
    downloadFontSize:'14px',
    appRequestOutline:'#F0F8FF',
    emissionButtonColor:"#2D3C86",
    emissionButtonHover:'#3b4a94',
    emissionButtonDisabled: "#6D6D6D",
    emissionButtonText:"white",
    timeElapsedColor:'#00edfc',
    editProfileButton:'#2D3C86',
    editProfileText:'white',
    editProfileHover:'#3b4a94',
    disabledText:'#808080',
    noDataText:'#c6c6c6',
    sendButton1: "#198754",
    sendButton2: "#d02f47",
    sendButton1Hover: "#146c43",
    sendButton2Hover: "#b0293e",
    companyasAcolor: "#846b3a",
    activeColor:"transparent",
    infoIconFillColor: "#1565c0",
    addIconBgColor: "#2d3c85",
    regionBoder: '#797979',
    menuListBackground: '#2684ff',
    menuListColor:'#ffffff',
    menuListHover:'#deebff',
    splineColor:'#1f77b4',
    barColor:'#ff7f0e',
    scope1ChartBackground:'#F0F8FF',
    scope2ChartBackground:'#FBFBFF',
    scope3ChartBackground:'#FFFFFF',
    smallUncertainty:"#616783",
    bigUncertainty:"#4d5ca9",
    smallUncertaintyText:"#4B4B4B",
    bigUncertaintyText:'#FFFFFF',
    groupReportTB:'#2D3C86',
    groupReportText: '#ffffff',
    calendarIcon:"#04c500",
    groupReportChildBorder:'none',
    groupReportBorder:"1px solid #5E5E5E",
    smallUncertaintyColor:"Grey",
    bigUncertaintyColor:"Blue",
  };
  
  export const DefaultInvertDark = (theme) => {
    return theme === "dark" ? "#C6C6C6" : "#303030";
  };

  export const DefaultLabel = (theme) => {
    return theme === "dark" ? "#C6C6C6" : "#303030";
  };

  export const DefaultTextFieldPlaceHolder =(theme) => {
    return theme === "dark" ? "#444d65" : "#989ea3";
  }

  export const DefaultTextField = (theme) => {
    return theme === "dark" ? "#182149" : "#ffffff";
  }


  export const DefaultActiveText = (theme) => {
    return theme === "light" ? '#ffffff' : '#ffffff';
  }

  export const DefaultInActiveText = (theme) => {
    return theme === "light" ? '#9da4c9' : '#9093a8';
  }

  export const DefaultActiveTab = (theme) => {
    return theme === "dark" ? "1px solid #182149" : "1px solid #fff";
  };

  export const DefaultAssetTab = (theme) => {
    return theme === "dark" ? "#202b60" : "#EEE";
  };

  export const DefaultModalBg = (theme) => {
    return theme === "dark" ? "#202b60" : "#F6F6F6";
  };
  
  